export const ARTICLE_EDITOR_SESSION_KEY = "article_editor_session";

export const saveArticleEditorSession = (session) => {
  if (!session?.workspaceActive) {
    sessionStorage.removeItem(ARTICLE_EDITOR_SESSION_KEY);
    return;
  }
  sessionStorage.setItem(
    ARTICLE_EDITOR_SESSION_KEY,
    JSON.stringify({
      articleId: session.articleId ?? null,
      article: session.article,
      previewOpen: Boolean(session.previewOpen),
      workspaceActive: true,
    })
  );
};

export const loadArticleEditorSession = () => {
  const raw = sessionStorage.getItem(ARTICLE_EDITOR_SESSION_KEY);
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw);
    if (!parsed?.workspaceActive || !parsed.article) {
      return null;
    }
    return {
      articleId: parsed.articleId ?? null,
      article: parsed.article,
      previewOpen: Boolean(parsed.previewOpen),
      workspaceActive: true,
    };
  } catch {
    sessionStorage.removeItem(ARTICLE_EDITOR_SESSION_KEY);
    return null;
  }
};

export const clearArticleEditorSession = () => {
  sessionStorage.removeItem(ARTICLE_EDITOR_SESSION_KEY);
};

export const sessionMatchesArticleContext = (session, articleId) => {
  if (!session?.workspaceActive) {
    return false;
  }
  const contextId = articleId ? String(articleId) : null;
  const sessionId = session.articleId ? String(session.articleId) : null;
  return contextId === sessionId;
};
